import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/ChatOnboarding/Steps/DiagnosticStep/mapDiagnosticCardsToPortfolioInsightPayload";
import type { DiagnosticCard } from "@/src/features/api/ChatApi";
import type { PortfolioInsightModalPayload } from "./types";

const I18n = I18nUtil.createScoped(Translations);

/** Maps API diagnostic cards into the Portfolio Insight modal payload. */
export function mapDiagnosticCardsToPortfolioInsightPayload(
  cards: DiagnosticCard[],
): PortfolioInsightModalPayload {
  return {
    headerTitle: I18n.t("Meet Ed"),
    headline: I18n.t("Read it. Three things stand out from your portfolio."),
    noticeLine: I18n.t("Here's what I noticed:"),
    insights: cards.map((card, index) => ({
      id: `${card.dimension}-${index}`,
      title: card.title,
      body: card.description,
    })),
    ctaLabel: I18n.t("See the trackers"),
  };
}
